/**
 * Module
 * @class
 */
class Singleton {

  /**
   * @static
   */
  static instance   = [];
  static isInternal = [];

  /**
   * @static
   */
  static getInstance() {
    const name_ = this.name;
    if(Singleton.instance[name_]){
      return Singleton.instance[name_];
    }
    Singleton.isInternal[name_] = true;
    return new this();
  }

  /**
   * @instance
   */
  constructor() {
    const name_ = this.constructor.name;
    if(!Singleton.isInternal[name_]){
      throw new Error(`Can't call new ${name}(), use ${name}.getInstance() instead.`);
    }
    Singleton.isInternal[name_] = false;
    Singleton.instance[name_]   = this;
  }

}

/**
 * class exports
 */
module.exports = Singleton;



/** WEBPACK FOOTER **
 ** ./webpack/requires/pattern/singleton.js
 **/